import { render, staticRenderFns } from "./Refinements.vue?vue&type=template&id=047d5354&"
import script from "./Refinements.vue?vue&type=script&lang=js&"
export * from "./Refinements.vue?vue&type=script&lang=js&"
import style0 from "./Refinements.vue?vue&type=style&index=0&id=047d5354&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports